import React from 'react';

import {
  SectionContainer,
  DriverInfoContainer,
  DriverInfoWrapper,
  InfoTitle,
  SliderTitle,
  TransportInfoWrapper,
  TitleWrapper,
  ShippingCompanyIcon,
} from '../styles';

import Mask from '../../../../../../../../utils/Mask';

const DriverSection = ({
  driverInfo,
  borderTop,
  borderTopColor,
  onlyShipping,
}) => {
  if (onlyShipping) {
    return (
      <SectionContainer
        borderTop={borderTop}
        borderTopColor={borderTopColor}
        paddingBottom
      >
        <SliderTitle style={{ marginBottom: '16px' }}>
          Dados do Transportador
        </SliderTitle>
        <DriverInfoContainer>
          <DriverInfoWrapper>
            <TransportInfoWrapper>
              <TitleWrapper>
                <InfoTitle color="#263465">Transportadora</InfoTitle>
                <InfoTitle medium color="#292F36">
                  {driverInfo.shippingCompany.corporateName ||
                    Mask.cnpj(driverInfo.shippingCompany.cnpj || '')}
                </InfoTitle>
              </TitleWrapper>
              {driverInfo?.shippingCompany?.icon ? (
                <ShippingCompanyIcon
                  src={driverInfo.shippingCompany?.icon}
                  alt="Logo"
                />
              ) : null}
            </TransportInfoWrapper>
          </DriverInfoWrapper>
        </DriverInfoContainer>
      </SectionContainer>
    );
  }

  return (
    <SectionContainer borderTop={borderTop} borderTopColor={borderTopColor}>
      <SliderTitle>Dados do Transportador</SliderTitle>
      <DriverInfoContainer>
        <DriverInfoWrapper>
          <InfoTitle bold color="#263465">
            Motorista
          </InfoTitle>
          <InfoTitle minHeght={32} color="#292F36" uppercase>
            {driverInfo.nomeMotorista}
          </InfoTitle>
        </DriverInfoWrapper>
        <DriverInfoWrapper>
          <InfoTitle bold color="#263465">
            Placa da carreta
          </InfoTitle>
          <InfoTitle minHeght={32} color="#292F36" uppercase>
            {driverInfo.tms.plate}
          </InfoTitle>
        </DriverInfoWrapper>
      </DriverInfoContainer>
      <DriverInfoContainer>
        <DriverInfoWrapper>
          <InfoTitle bold color="#263465">
            Transportadora
          </InfoTitle>
          <InfoTitle minHeght={32} color="#292F36" uppercase>
            {driverInfo.shippingCompany.corporateName ||
              Mask.cnpj(driverInfo.shippingCompany.cnpj || '')}
          </InfoTitle>
        </DriverInfoWrapper>
        <DriverInfoWrapper>
          <InfoTitle bold color="#263465">
            CPF do Motorista
          </InfoTitle>
          <InfoTitle minHeght={32} color="#292F36" uppercase>
            {driverInfo.cpfMotorista}
          </InfoTitle>
        </DriverInfoWrapper>
      </DriverInfoContainer>
      <DriverInfoContainer>
        <DriverInfoWrapper>
          <InfoTitle bold color="#263465">
            Placa do Cavalo
          </InfoTitle>
          {driverInfo.tms.placaCavalo ? (
            <InfoTitle minHeght={32} color="#292F36" uppercase>
              {driverInfo.tms.placaCavalo}
            </InfoTitle>
          ) : (
            <InfoTitle minHeght={32} color="#292F36" uppercase>
              {driverInfo.tms.plate}
            </InfoTitle>
          )}
        </DriverInfoWrapper>
      </DriverInfoContainer>
    </SectionContainer>
  );
};

export default DriverSection;
